export default __webpack_public_path__ + "static/media/status-color-1.06ace088.png";